import React from 'react';

import styles from './board.less';
import { SectionHeader } from './section-header';
import { Tile, TileIcon, TileLink, TileLinkText, TileText } from './tile';

import { forTemplate } from 'common/lib/util/i18n';
const l = forTemplate('home');

interface BoardListProps {
  boardIds: string[];
  boardsType: string;
  isDraggable: boolean;
  numBoardsVisible: number;
  orgId: string;
  renderBoardTile: (
    boardId: string,
    boardsType: string,
    isDraggable: boolean,
    orgId: string,
  ) => JSX.Element;
  showAll: boolean;
}
export const BoardList: React.StatelessComponent<BoardListProps> = ({
  boardIds,
  boardsType,
  isDraggable,
  numBoardsVisible,
  orgId,
  renderBoardTile,
  showAll,
}) => (
  <>
    {boardIds.map((boardId, index) => {
      if (index < numBoardsVisible || showAll) {
        return renderBoardTile(boardId, boardsType, isDraggable, orgId);
      }
    })}
  </>
);

interface BoardSectionProps {
  boardIds: string[];
  boardsType: string;
  isDraggable: boolean;
  numBoardsVisible: number;
  onShowFewerClick: () => void;
  onShowMoreClick: () => void;
  orgId: string;
  renderBoardTile: (
    boardId: string,
    boardsType: string,
    isDraggable: boolean,
  ) => JSX.Element;
  sectionHeaderTitle: string;
  sectionHeaderIconName: string;
  showAll: boolean;
}
export const BoardSection: React.StatelessComponent<BoardSectionProps> = ({
  boardIds,
  boardsType,
  isDraggable,
  numBoardsVisible,
  onShowFewerClick,
  onShowMoreClick,
  orgId,
  renderBoardTile,
  sectionHeaderTitle,
  sectionHeaderIconName,
  showAll,
}) => (
  <div className={styles.boardSection}>
    <SectionHeader iconName={sectionHeaderIconName}>
      {sectionHeaderTitle}
    </SectionHeader>
    <BoardList
      boardIds={boardIds}
      boardsType={boardsType}
      isDraggable={isDraggable}
      numBoardsVisible={numBoardsVisible}
      orgId={orgId}
      renderBoardTile={renderBoardTile}
      showAll={showAll}
    />
    {boardIds.length > numBoardsVisible && (
      <Tile>
        {!showAll ? (
          <TileLink onClick={onShowMoreClick} isButton>
            <TileIcon name="down" />
            <TileText>
              <TileLinkText>{l('show-more')}</TileLinkText>
            </TileText>
          </TileLink>
        ) : (
          <TileLink onClick={onShowFewerClick} isButton>
            <TileIcon name="up" />
            <TileText>
              <TileLinkText>{l('show-fewer')}</TileLinkText>
            </TileText>
          </TileLink>
        )}
      </Tile>
    )}
  </div>
);



// WEBPACK FOOTER //
// ./app/scripts/views/home/presentational/board.tsx